import request from "@/utils/request";

const cache = {};

const service = async (obj) => {
  const key = obj.url + JSON.stringify(obj.params);

  if (key && cache[key]) {
    return cache[key];
  }

  const response = await request(obj);

  if (key) {
    cache[key] = response;
  }

  return response;
};

export default service;
